const CLASSES = {
  error: 'is-error',
  hidden: 'is-none'
}

// 呼叫 form error
const useFormError = (id, text, timeout) => {
  const target = document.querySelector(`[data-group-id="${id}"]`)
  if (!target) return;

  const { error, hidden } = CLASSES
  const isDefaultHidden = target.classList.contains(hidden)
  const errorField = target.querySelector('.form-group_error .error-msg')
  const inputField = target.querySelector('.form-group_input')

  if (inputField) {
    inputField.focusHandler = () => {
      target.classList.remove(error)
      inputField.removeEventListener('click', inputField.focusHandler)
      inputField.focusHandler = null
    }

    inputField.addEventListener('click', inputField.focusHandler)
  }

  if (errorField && text) {
    errorField.innerHTML = text
  }

  if (timeout) {
   setTimeout(() => {
    target.classList.remove(error)

    if (isDefaultHidden) {
      target.classList.add(hidden)
    }
   }, timeout) 
  }

  if (isDefaultHidden) {
    target.classList.remove(hidden)
  }

  target.classList.add(error)
}

// 移除 form error
const removeFormError = (id) => {
  const target = document.querySelector(`[data-group-id="${id}"]`)
  if (!target) return;

  const { error } = CLASSES
  const inputField = target.querySelector('.form-group_input')

  if (inputField) {
    target.classList.remove(error)
    inputField.removeEventListener('click', inputField.focusHandler)
    inputField.focusHandler = null
  }
}


// 密碼顯示明碼或暗碼
const usePlainCode = () => {
  const passwordInputs = document.querySelectorAll('input[type="password"]');

  const createEyeBtn = () => {
    const eyeBtn = document.createElement('button')
    eyeBtn.classList.add('eye-btn', 'input-btn')
    eyeBtn.setAttribute('type', 'button')
    eyeBtn.innerHTML = '<i class="be-icon be-icon-eye"></i>'
    return eyeBtn
  }

  [...passwordInputs].forEach(el => {
    const input = el
    const eyeBtn = createEyeBtn()

    eyeBtn.addEventListener('click', () => {
      if (input.type === 'password') {
        input.type = 'text'
        eyeBtn.classList.add('is-visable')
      }
      else {
        input.type = 'password'
        eyeBtn.classList.remove('is-visable')
      }
    })

    input.before(eyeBtn)
  })
}

// datepicker
const useDatepicker = () => {
  const pickers = document.querySelectorAll('[data-datepicker]')
  const date = new Date()
  const nowYear = date.getFullYear()
  const range = 60

  const createOption = (val) => {
    const option = document.createElement('option')
    option.value = option.innerHTML = val
    return option
  }

  ;[...pickers].forEach(el => {
    const yearPicker = el.querySelector('[data-datepicker-year]')
    const monthPicker = el.querySelector('[data-datepicker-month]')
    const datePicker = el.querySelector('[data-datepicker-days]')

    for(let i = nowYear; i > nowYear - range; i --) {
      const option = createOption(i)
      yearPicker.append(option)
    }

    const setDays = () => {
      const year = yearPicker.value
      const month = monthPicker.value
      if (isNaN(parseInt(year)) || isNaN(parseInt(month))) return;

      const lastDayOfMonth = new Date(year, month , 0).getDate()
      for (let i = 1; i < 32; i++) {
        if (i > lastDayOfMonth && datePicker.querySelector(`[value="${i}"]`)) {
          datePicker.querySelector(`[value="${i}"]`).remove()
        }
        if (i <= lastDayOfMonth && !datePicker.querySelector(`[value="${i}"]`)) {
          const option = createOption(i)
          datePicker.append(option)
        }
      }
    }

    yearPicker.addEventListener('change', setDays)
    monthPicker.addEventListener('change', setDays)
  })
}

// textarea 字數上限
const useTextareaLimit = () => {
  const textareas = document.querySelectorAll('[data-textarea-limit]')
  if (!textareas.length) return;

  ;[...textareas].forEach(el => {
    const limit = parseInt(el.getAttribute('data-textarea-limit'))
    if (!limit) return;

    // create counter
    const counter = document.createElement('div')
    counter.classList.add('textarea-limit')
    counter.innerHTML = `<span class="num">0</span>/${limit}`
    el.append(counter)
    
    // addEventListener
    const input = el.querySelector('.textarea-input')
    const num = counter.querySelector('.num')
    if (!input) return;
    input.addEventListener('input', () => {
      const len = input.value.length
      num.innerText = len
    })
  })
}

// input-select 可輸入及選擇之輸入框
const useInputSelect = () => {
  const inputs = [...document.querySelectorAll('.input-select')]
  if (!inputs.length) return;

  inputs.forEach(el => {
    const input = el.querySelector('.input-select_input')
    const select = el.querySelector('.input-select_select')
    if (!input || !select) return;
  
    select.addEventListener('change', () => {
      const value = select.value
      input.value = value
    })
  })
}


// 輸入時驗證手機號碼
const phoneReg = /^09\d{8}$/
const verifyPhoneNumber = (val) => phoneReg.test(val)
const useVerifyPhone = (id = '#account') => {
  const accountField = document.querySelector(id)
  const captchaBtn = document.querySelector('#captcha-btn')

  if (!accountField || !captchaBtn) return;

  accountField.addEventListener('input', () => {
    verifyPhoneNumber(accountField.value) ? captchaBtn.classList.remove('is-disabled') : captchaBtn.classList.add('is-disabled')
  })
}


export {
  useFormError,
  removeFormError,
  usePlainCode,
  useDatepicker,
  useTextareaLimit,
  useVerifyPhone,
  useInputSelect
}